const signInES = {
	title: "Iniciar sesión",
	email: "Correo electrónico",
	password: "Contraseña",
	rememberMe: "Recordarme",
	button: "Iniciar sesión",
	loading: "Iniciando...",
	forgotPassword: "¿Olvidaste tu contraseña?",
	noAccount: "¿No tienes una cuenta?",
	registerLink: "Regístrate",
};
export default signInES;
